import React from 'react';
import { useIntl } from 'react-intl';
import { WebChatColorProps } from "@42maru/webchat";

import { WebchatColorFormProps } from '.';
import { WebchatColorPicker } from '../component';


const MessageBoxColorInputGroup: React.FC<WebchatColorFormProps> = (props) => {
    const { colors, legend, onChange } = props;

    const intl = useIntl();

    const onChangeColor = (color: string, key: keyof WebChatColorProps) => {
        onChange({ ...colors, [key]: color });
    };

    return (
        <div className="webchat-setting-card-color-container">
            <fieldset className="color-setting-container">
                <legend className="field-label-bold">
                    {legend}
                </legend>

                <div className="color-setting-body">
                    <div className="color-setting-row">
                        <div className="input-label">
                            {intl.formatMessage({ id: "i09042" })}
                        </div>
                        <WebchatColorPicker aria-label={intl.formatMessage({ id: "i09042" })}
                                            colorKey="chatInputAreaBackgroundColor"
                                            colors={colors}
                                            onChange={onChangeColor}
                        />
                        <div className="input-label">
                            {intl.formatMessage({ id: "i09043" })}
                        </div>
                        <WebchatColorPicker aria-label={intl.formatMessage({ id: "i09043" })}
                                            colorKey="chatInputBackgroundColor"
                                            colors={colors}
                                            onChange={onChangeColor}
                        />
                        <div className="input-label">
                            {intl.formatMessage({ id: "i09044" })}
                        </div>
                        <WebchatColorPicker aria-label={intl.formatMessage({ id: "i09044" })}
                                            colorKey="chatInputTextColor"
                                            colors={colors}
                                            onChange={onChangeColor}
                        />
                    </div>
                    <div className="color-setting-row">
                        <div className="input-label">
                            {intl.formatMessage({ id: "i09045" })}
                        </div>
                        <WebchatColorPicker aria-label={intl.formatMessage({ id: "i09045" })}
                                            colorKey="chatInputPlaceHolderColor"
                                            colors={colors}
                                            onChange={onChangeColor}
                        />
                        <div className="input-label">
                            {intl.formatMessage({ id: "i09046" })}
                        </div>
                        <WebchatColorPicker aria-label={intl.formatMessage({ id: "i09046" })}
                                            colorKey="chatInputSendButtonColor"
                                            colors={colors}
                                            onChange={onChangeColor}
                        />
                    </div>
                </div>
            </fieldset>

            <fieldset className="color-setting-container">
                <legend className="field-label-bold">
                    {intl.formatMessage({ id: "b0034" })}
                </legend>
                <div className="color-setting-body">
                    <div className="color-setting-row">
                        <div className="input-label">
                            {intl.formatMessage({ id: "i09048" })}
                        </div>
                        <WebchatColorPicker colorKey="autocompleteHighlightColor"
                                            colors={colors}
                                            aria-label={intl.formatMessage({ id: "i09048" })}
                                            onChange={onChangeColor}
                        />
                    </div>
                </div>
            </fieldset>
        </div>
    );
};

export default MessageBoxColorInputGroup;
